import type { SheetPixels } from "common/types/nominalNumbersTypes";
import type { PolyLine2 } from "geom/polyLine2Types";
import { polyLine2New } from "geom/polyLine2Types";
import { SVGLoader } from "./SVGLoader";

const SVGLoaderInternal = new SVGLoader(); // maybe init like the PDFInternal

export function planSVGBezierStringToPolyLine2(svg: string): Promise<PolyLine2[]> {
  return new Promise((resolve) => {
    const data = SVGLoaderInternal.load(svg);
    if (data) {
      const paths = data.paths;
      const out: PolyLine2[] = [];
      for (const path of paths) {
        const shapes = path.toShapes(true);
        for (const shape of shapes) {
          const points = shape.getPoints();
          if (points.length > 0) {
            const pl = polyLine2New(points.length * 2);
            points.forEach((v, i) => {
              v.toArray(pl as unknown as ArrayLike<SheetPixels>, i * 2);
            });
            out.push(pl);
          }
        }
      }
      resolve(out);
    }
  });
}
